import React from "react";
import sidebarLogo from "../../../../assets/img/square-logo-white.png";
import { HERO_PREVIEW_SPEED_OPTIONS } from "../../heroPreviewSpeed";

const PresentScreenHeroPreviewSpeed = ({ activeSpeedId, onSpeedChange }) => (
  <div
    className="landing-v2-present-hero__preview-speed"
    role="toolbar"
    aria-label="Automation preview speed"
  >
    <span className="landing-v2-present-hero__preview-speed-label" aria-hidden="true">Speed</span>
    {HERO_PREVIEW_SPEED_OPTIONS.map((option) => {
      const isActive = option.id === activeSpeedId;

      return (
        <button
          key={option.id}
          type="button"
          className={`landing-v2-present-hero__preview-speed-btn${
            isActive ? " landing-v2-present-hero__preview-speed-btn--active" : ""
          }`}
          aria-label={option.label}
          aria-pressed={isActive}
          onClick={() => onSpeedChange(option.id)}
        >
          {option.id === "slow" ? (
            <i className="fa-solid fa-plane" aria-hidden="true" />
          ) : null}
          {option.id === "medium" ? (
            <i className="fa-solid fa-jet-fighter" aria-hidden="true" />
          ) : null}
          {option.id === "fast" ? (
            <img
              className="landing-v2-present-hero__preview-speed-logo"
              src={sidebarLogo}
              alt=""
            />
          ) : null}
        </button>
      );
    })}
  </div>
);

export default PresentScreenHeroPreviewSpeed;
